import { createAction } from '@reduxjs/toolkit';
import { eventsTypes } from 'types';

export const EVENTS_SAGA = 'EVENTS_SAGA';
export const eventsSaga = createAction<eventsTypes.IEventForm>(EVENTS_SAGA);

export const SINGLE_EVENTS_SAGA = 'SINGLE_EVENTS_SAGA';
export const singleEventsSaga = createAction<number>(SINGLE_EVENTS_SAGA);
